module.exports = __webpack_public_path__ + "static/media/stakePromo.845f828f.webp";